import { cloudChiprApi } from "../../../../../../services/cloudchipr.api";

export const costBreakdownV2WidgetByWidgetIdSelector =
  cloudChiprApi.endpoints
    .getUsersMeOrganisationsCurrentWidgetsCostBreakdownByWidgetId.select;
